import { ScrollContainer } from '@codezo/ui';
import { NewsletterSubscribersTable } from '../components/NewsletterSubscribersTable';

export function NewsletterPage() {
	return (
		<ScrollContainer>
			<NewsletterSubscribersTable />
		</ScrollContainer>
	);
}
